define('model/provisional.organization.model',['require','exports','module','fukit','backbone.radio','datakit/datakit'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel = require('fukit').BaseModel,
      Radio     = require('backbone.radio');
      DataKit   = require('datakit/datakit');

      //Radio channels
      UIChannel = Radio.channel('UIChannel');

  var ProvisionalOrganizationModel = BaseModel.extend({
    radioRequests: {
      'models ProvisionalOrganizationModel': '@constructor',
    },

    initialize: function() {
      BaseModel.prototype.initialize.apply(this, arguments);

      this.on('error', function() {
        UIChannel.request('proposal:ui:reset');
      });
    },

    urlRoot: '/api/v2/unit/provisional/combined',

    saveUrl: '/api/v2/unit/provisional',

    save: function(attrs, options) {
      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            url: DataKit.url.template(this.saveUrl, this, this._urlParams),
          },
          options
        )
      );
    },

    externalOrgUrl: '/api/v2/coi/disclosure/extOrgs/:disclosureId',

    saveExternalOrg: function(attrs, options) {
      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            url: DataKit.url.template(this.externalOrgUrl, this, this._urlParams),
            type: 'POST',
            contentType: 'application/json',
          },
          options
        )
      );
    },

    submitOrgUrl: '/api/v2/coi/disclosure/extOrgs/submit/:disclosureId',

    saveSubmittedExternalOrg: function(attrs, options) {
      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            url: DataKit.url.template(this.submitOrgUrl, this, this._urlParams),
            type: 'PUT',
            contentType: 'application/json',
          },
          options
        )
      );
    },

    clearReviewerAssignmentUrl:
      '/api/v1/compliance/assignment/typeFieldName/disclosureReviewer/disclosure/:disclosureId/remove',

    clearReviewerAssignment: function(attrs, options) {
      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            url: DataKit.url.template(this.clearReviewerAssignmentUrl, this, this._urlParams),
            type: 'DELETE',
            contentType: 'application/json',
          },
          options
        )
      );
    },

    deleteExternalOrg: function() {
      var attrs = this.attributes || {};

      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend({
          url: DataKit.url.template(this.externalOrgUrl, this, this._urlParams),
          type: 'PUT',
        })
      );
    },
  });

  module.exports = ProvisionalOrganizationModel;
});

